export default "__VITE_ASSET__dfd957a1__"